// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Wz","styleWarning":"e_Xz"};